<template>
  <LcRadioCard
    :label="$t('account.payout.accounts.bankaccount')"
    label-class="paragraph-bold"
    :value="id"
  >
    <template #default>
      <PaymentMethodSymbol variant="Bank" />
    </template>

    <template #bottom>
      <PayoutMethodDescriptedListBank v-bind="{ accountNumber, holderName, routingNumber }" />
    </template>
  </LcRadioCard>
</template>

<script setup lang="ts">
import type { PayOutAccountBank } from '../../../../../core/api/shared/@types/generated/backend/graphql-schema-types'

import PayoutMethodDescriptedListBank from './PayoutMethodDescriptedListBank.vue'

type PayoutStoredMethodBankProps = Omit<PayOutAccountBank, '__typename'>

defineProps<PayoutStoredMethodBankProps>()
</script>
